import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@shared/services/api/apiRequest";
import { QUIZ_RESPONSE_SET, useQuizDispatch, useQuiz } from "../../QuizContext";
import { normalizeQuizResponseData } from "./normalizeQuizResponseData";

type Props = {
  quizResponseId: number;
};

export function useGetQuizResponse({ quizResponseId }: Props) {
  const dispatch = useQuizDispatch();

  const { quiz } = useQuiz();

  const query = useQuery({
    queryKey: ["quiz-response", quizResponseId],
    queryFn: async () =>
      apiRequest(`/api/quiz-response/${quizResponseId}/`, "GET"),
    enabled: !!quizResponseId,
    select: (data) => {
      return {
        quizResponse: data.quiz_response,
        quiz: normalizeQuizResponseData(data.quiz),
      };
    },
  });

  useEffect(() => {
    if (query.data) {
      dispatch({ type: QUIZ_RESPONSE_SET, payload: query.data });
    }
  }, [query.data, dispatch]);

  return { ...query, quiz };
}

export default useGetQuizResponse;
